import { render, staticRenderFns } from "./AggiungiModificaUtenza.vue?vue&type=template&id=f2a3a632&"
import script from "./AggiungiModificaUtenza.vue?vue&type=script&lang=js&"
export * from "./AggiungiModificaUtenza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports